const GenericNotFoundIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={340}
    height={340}
    viewBox="0 0 340 340"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#fff"
        d="M0 0h340v340H0z"
      />
      <path
        fill="#EFF1F4"
        d="M18.205 158.751c-.07 1.399-.045 2.823-.02 4.247.587 20.914 10.154 42.411 27.07 55.043 20.817 15.5 47.597 15.184 72.337 16.042 13.879.479 24.812 8.167 32.332 19.497 9.496 14.188 16.956 32.184 31.657 42.097 24.441 16.37 55.505 21.656 82.051 12.367 12.316-4.294 23.465-11.432 31.964-20.798 8.479-9.675 14.188-21.51 16.368-34.19 2.274-12.654 1.113-26.128-3.653-38.644-5.631-14.974-15.922-28.464-28.735-38.985-22.715-18.641-52.551-20.561-68.884-47.111-6.997-11.392-11.188-24.159-19.53-34.697-8.109-10.272-18.624-18.76-30.518-24.376-44.903-21.448-92.705.877-121.305 37.155-11.994 15.214-20.649 32.74-21.228 52.328l.094.025Z"
      />
      <path
        fill="#DDE3EE"
        d="M42.668 282.371h218.45l15.3 28.73H29.238l13.43-28.73Z"
      />
      <path
        fill="#fff"
        d="m297.67 149.598 20.74-6.12 6.97-.85 7.82-2.04 7.48-3.91 2.38 115.09-34.68-2.89-7.31-3.74-5.1-7.82-3.06-14.96-.85-15.81 2.04-31.45-41.14-14.79-8.84-1.53-39.1-1.53-8.84-23.29 24.31-3.06h23.63l23.46 3.57 15.98 5.44 14.11 9.69Z"
      />
      <path
        fill="#fff"
        d="M42.839 202.98h218.11l15.47 18.7v88.57l-15.47-27.88H42.839l-13.43 28.22-.85-88.23 14.28-19.38ZM165.581 152.488l5.95 1.87 4.93 4.42-3.23 5.27-6.12 5.78v2.72l1.7 2.89.85 7.99-2.55 6.46-6.8 4.08-6.97.85-3.06-6.8.34-6.8 4.08-6.12 7.65-5.44-2.38-5.61-.85-6.63 6.46-4.93Z"
      />
      <path
        stroke="#475161"
        strokeWidth={1.36}
        d="m29.154 305.215-5.545 5.853v16.634h258.756v-16.634l-5.852-5.699M29.156 222.043v89.025m0-89.025 13.862-19.406m-13.862 19.406h247.358M29.156 311.068h247.358m-247.358 0 13.862-28.648m-13.862 28.648h-5.699m19.56-108.431h218.095m-218.094 0v79.783m218.094-79.783 15.402 19.406m-15.402-19.406v79.783m15.402-60.377v89.025m0 0-15.402-28.648m15.402 28.648h5.545M43.018 282.42h218.094M180.944 258.203c-13.997-16.966-24.805-9.905-28.687-3.982a.75.75 0 0 0-.055.698c7.864 18.887 22.413 10.094 28.742 3.284Zm0 0c1.038-2.119 4.488-6.454 10.115-7.239a.363.363 0 0 1 .416.375c-.097 2.16-.928 6.325-3.7 8.8a.202.202 0 0 0-.035.259c.972 1.517 2.343 5.132.892 8.835a.351.351 0 0 1-.47.199c-2.082-.93-5.974-4.226-7.218-11.229Z"
      />
      <circle
        cx={158.736}
        cy={254.255}
        r={1.157}
        fill="#475161"
        transform="rotate(9.107 158.736 254.255)"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="M58.73 282.421c-.719-5.442-1.725-17.065 0-20.023M58.575 281.96c-2.618-3.492-7.793-11.152-7.547-13.862"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="M58.574 281.958c1.797-3.696 5.884-11.336 7.855-12.321M100.941 282.421c-.719-5.442-1.725-17.065 0-20.023M100.786 281.96c-2.618-3.492-7.793-11.152-7.547-13.862"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="M100.785 281.958c1.797-3.696 5.884-11.336 7.855-12.321M230.011 282.109c-.719-5.442-1.725-17.066 0-20.023M229.856 281.647c-2.618-3.491-7.793-11.151-7.547-13.862"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="M229.855 281.646c1.797-3.697 5.884-11.336 7.856-12.322M241.406 282.109c-.719-5.442-1.725-17.066 0-20.023"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="M241.251 281.647c-2.619-3.491-7.794-11.151-7.547-13.862"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="M241.25 281.646c1.797-3.697 5.884-11.336 7.855-12.322"
      />
      <circle
        cx={86.758}
        cy={238.372}
        r={4.005}
        stroke="#475161"
        strokeWidth={1.36}
      />
      <circle
        cx={89.223}
        cy={249.461}
        r={2.156}
        stroke="#475161"
        strokeWidth={1.36}
      />
      <circle
        cx={1.36}
        cy={1.36}
        r={1.36}
        stroke="#475161"
        strokeWidth={0.34}
        transform="matrix(1 0 0 -1 144.496 247.176)"
      />
      <circle
        cx={148.915}
        cy={250.579}
        r={1.36}
        stroke="#475161"
        strokeWidth={0.34}
      />
      <g
        fill="#6E6B86"
        opacity={0.5}
      >
        <circle
          cx={50.718}
          cy={295.359}
          r={2.464}
        />
        <circle
          cx={162.54}
          cy={297.821}
          r={2.464}
          transform="rotate(-180 162.54 297.821)"
        />
        <circle
          cx={240.165}
          cy={301.825}
          r={2.464}
          transform="rotate(-180 240.165 301.825)"
        />
        <circle
          cx={62.732}
          cy={289.197}
          r={3.697}
        />
        <circle
          cx={150.526}
          cy={303.983}
          r={3.697}
          transform="rotate(-180 150.526 303.983)"
        />
        <circle
          cx={215.522}
          cy={298.44}
          r={3.697}
          transform="rotate(-180 215.522 298.44)"
        />
        <circle
          cx={230}
          cy={302.441}
          r={2.156}
          transform="rotate(-180 230 302.441)"
        />
        <circle
          cx={202.889}
          cy={289.503}
          r={3.697}
          transform="rotate(-180 202.889 289.503)"
        />
        <circle
          cx={55.339}
          cy={305.214}
          r={2.464}
        />
        <circle
          cx={157.918}
          cy={287.965}
          r={2.464}
          transform="rotate(-180 157.918 287.965)"
        />
        <circle
          cx={224.762}
          cy={290.735}
          r={2.464}
          transform="rotate(-180 224.762 290.735)"
        />
        <circle
          cx={71.048}
          cy={299.978}
          r={3.697}
        />
        <circle
          cx={142.206}
          cy={293.202}
          r={3.697}
          transform="rotate(-180 142.206 293.202)"
        />
        <circle
          cx={249.096}
          cy={291.046}
          r={3.697}
          transform="rotate(-180 249.096 291.046)"
        />
        <circle
          cx={259.57}
          cy={302.132}
          r={1.848}
          transform="rotate(-180 259.57 302.132)"
        />
        <circle
          cx={1.848}
          cy={1.848}
          r={1.848}
          transform="matrix(1 0 0 -1 77.21 291.047)"
        />
        <circle
          cx={1.848}
          cy={1.848}
          r={1.848}
          transform="matrix(-1 0 0 1 136.047 302.137)"
        />
        <circle
          cx={1.848}
          cy={1.848}
          r={1.848}
          transform="matrix(-1 0 0 1 202.273 302.137)"
        />
        <circle
          cx={90.456}
          cy={301.518}
          r={2.772}
        />
        <circle
          cx={122.798}
          cy={291.661}
          r={2.772}
          transform="rotate(-180 122.798 291.661)"
        />
        <circle
          cx={186.259}
          cy={290.427}
          r={2.772}
          transform="rotate(-180 186.259 290.427)"
        />
        <circle
          cx={102.161}
          cy={292.587}
          r={1.54}
        />
        <circle
          cx={111.093}
          cy={300.596}
          r={1.54}
          transform="rotate(-180 111.093 300.596)"
        />
        <circle
          cx={181.944}
          cy={302.44}
          r={1.54}
          transform="rotate(-180 181.944 302.44)"
        />
      </g>
      <circle
        cx={213.367}
        cy={247.305}
        r={2.156}
        stroke="#475161"
        strokeWidth={1.36}
      />
      <circle
        cx={210.903}
        cy={236.215}
        r={4.005}
        stroke="#475161"
        strokeWidth={1.36}
      />
      <path
        fill="#6E6B86"
        d="m384.465 250.084-16.783-1.321-21.199 2.201-21.641-.88-13.249-2.201-7.95 13.205-6.183 14.965-4.417 26.85-1.325 26.41 2.209 47.977 3.533 16.286 5.741 14.966 11.483 2.201 12.366-1.321 11.041-5.282-6.183-11.444-3.974-39.174 2.714-28.314 4.59-28.05 1.53 1.87 6.8 18.7 16.606 34.473 24.291 51.939 4.416 4.402 23.849-11.004 7.508-8.363-16.341-29.931-15.016-54.14-3.533-27.29-.883-27.73Z"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="M299.197 143.297c-7.48 36.72-15.368 109.14 12.92 105.06M386.074 407.041c-17.027-34.935-51.257-107.182-51.961-116.693"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="M335.432 296.954c-5.871 26.421-13.563 84.811 2.642 107.005-5.871 4.404-21.225 11.185-35.668 3.082-18.055-38.75-13.004-138.946 9.542-158.674M312.121 248.199c7.027 2.437 24.922 4.42 34.17 1.02"
      />
      <path
        fill="#F9F8FF"
        d="m330.704 68.968-9.942-17.318-14.949-3.09-15.889 5.84-6.253 10.515-1.233 8.403 48.377-1.932-.111-2.418Z"
      />
      <path
        fill="#F9F8FF"
        d="m332.598 70.328-77.836 5.426.257 5.642 55.021-3.849 12.482-3.799 10.259.61-.183-4.03Z"
      />
      <path
        fill="#fff"
        d="m342.723 113.029-6.676-7.805-3.648-13.675-11.782-7.583-11.872-6.46-26.27 2.541-2.557 27.828a14.344 14.344 0 0 0 1.039 6.815l1.055 2.535 35.548 26.084h8.5l9.987-3.74 14.702-8.778 6.979-8.238-15.005-9.524Z"
      />
      <path
        fill="#475161"
        d="m333.721 76.515-11.383-1.636-8.427 4.153-7.608 10.308-3.407 13.887-6.412 7.023-9.221 4.458-4.274 6.656-1.258 7.866 4.691 14.326 9.709 6.289 10.309 1.685-.135-2.955 5.044-1.576 6.815-4.079 2.699-11.701-1.809-16.073-2.809-14.411-1.784-9.612 2.504-4.153 4.739-2.37 4.213 3.848 2.284 2.858-4.03 6.106 3.493-.159 7.755-7.084 1.869-6.277-3.567-7.377Z"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="m316.657 77.667-59.528 4.073c-3.961-.678-3.79-4.833-2.878-6.451.231-.41.704-.56 1.173-.59l75.903-5.086c2.329.288.915 5.422.464 5.499M282.333 72.76c-4.813-17.014 36.181-42.28 48.569-3.287"
      />
      <path
        stroke="#475161"
        strokeMiterlimit={10}
        strokeWidth={1.36}
        d="M315.789 77.7c-3.999 2.428-5.896 5.894-8.042 10.003-4.634 8.668-2.259 11.055-5.64 16.549-5.372 8.763-13.217 5.803-17.84 14.252-3.961 7.18-1.619 15.305-1.023 17.186.575 1.776 2.999 8.966 10.055 12.842 6.129 3.306 13.407 2.919 13.624 1.848.082-.395-.668-1.163-5.09-2.975 1.301.549 3.267 1.18 5.638 1.134 2.745-.067 5.197-1.048 5.124-1.412-.063-.312-1.467-.029-2.789-.952-.811-.539-1.239-1.318-1.531-1.962 2.414.973 5.305 1.634 7.747.33 6.534-3.535 4.668-19.219 4.046-24.447-1.992-16.848-8.608-24.976-4.013-31.96.374-.562 2.23-3.424 4.923-3.48 3.4-.037 6.86 4.51 6.491 8.045-.359 3.047-3.414 4.528-3.101 5.006.448.613 5.748-1.538 9.577-6.15 1.39-1.686 2.574-3.06 2.851-5.171.555-3.681-1.696-7.337-4.091-9.287-5.018-3.963-12.585-2.058-16.916.6Z"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="m283.306 80.547-3.397 30.813a.209.209 0 0 0 .264.223l8.74-2.481M296.165 85.079c-1.751-.998-5.807-2.16-8.024 1.172M280.258 90.52c-1.75-.997-5.806-2.16-8.024 1.173"
      />
      <circle
        cx={2.152}
        cy={2.152}
        r={2.152}
        fill="#475161"
        transform="scale(-1 1) rotate(2.605 -2097.328 -6413.346)"
      />
      <circle
        cx={2.152}
        cy={2.152}
        r={2.152}
        fill="#475161"
        transform="scale(-1 1) rotate(2.605 -2187.738 -6083.989)"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="M333.192 90.969c-.664 5.768 1.981 19.672 17.869 29.137m-35.859 23.023c13.502 2.192 28.098-7.151 37.343-15.335"
      />
      <path
        stroke="#475161"
        strokeWidth={1.36}
        d="M166.103 168.614c-20.501 7.97-17.185 20.448-12.778 25.991.153.192.401.29.645.272 20.401-1.546 16.614-18.118 12.133-26.263Zm0 0c-1.687-1.651-4.721-6.286-3.703-11.875a.363.363 0 0 1 .487-.277c2.021.769 5.715 2.865 7.196 6.273.039.09.139.139.235.114 1.745-.448 5.608-.615 8.669 1.923.156.13.178.359.041.509-1.536 1.685-5.886 4.348-12.925 3.333Z"
      />
      <circle
        cx={155.387}
        cy={188.466}
        r={1.157}
        fill="#475161"
        transform="rotate(-62.617 155.387 188.466)"
      />
      <path
        fill="#fff"
        d="m187.457 141.591 10.252-2.871 5.27 13.623-11.3 4.304-3.2 4.093-6.118 2.677-4.881 3.524-4.32 3.871-3.052 3.268h-1.876l-1.463-2.04.69-2.079 1.428-2.51 2.812-3.571 1.87-4.907-1.7-1.893-9.69-1.87-2.252 4.584-.125-2.047 8.43-11.627 18.345-2.553.88-1.976Z"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="m294.1 175.268-38.942-14.339a32.985 32.985 0 0 0-10.156-2.008l-37.923-1.426a3.06 3.06 0 0 1-2.762-2.015l-6.64-18.327a2.72 2.72 0 0 1 2.195-3.632c28.045-3.716 83.778-12.121 99.838 10.467"
      />
      <path
        stroke="#475161"
        strokeWidth={1.36}
        d="m198.204 137.827-10.714 3.778a2.013 2.013 0 0 0-1.325 1.625.673.673 0 0 1-.581.574l-15.715 1.99a5.1 5.1 0 0 0-3.521 2.11l-6.356 8.969a4.075 4.075 0 0 0-.745 2.582l.038.692c.454 3.17 1.872 9.578 3.912 9.851"
      />
      <path
        stroke="#475161"
        strokeWidth={1.36}
        d="M166.257 158.608c1.805-1.337 5.08-2.546 6.434-.753 1.414 1.871.12 3.925-1.148 5.898l-.304.473c-.292.335-.68.781-1.098 1.265-1.806 2.085-4.327 4.633-3.099 7.102.226.455.544.836.893 1.144.744.659 1.836.35 2.485-.403l1.578-1.833 5.178-4.701c1.246-1.023 4.062-3.175 5.364-3.592 1.627-.52 5.106-2.207 6.058-3.226.709-.76 1.681-2.234 2.282-3.079a.655.655 0 0 1 .331-.243c3.341-1.109 10.119-3.29 12.078-3.657"
      />
      <path
        stroke="#475161"
        strokeWidth={1.36}
        d="m171.219 156.984-.152 1.105a1.7 1.7 0 0 0 1.453 1.915l.772.106"
      />
      <path
        stroke="#475161"
        strokeLinecap="round"
        strokeWidth={1.36}
        d="M339.277 106.453v233.546"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill="#fff"
          d="M0 0h340v340H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

const LearningPathCourseIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.29096 2.3806C2.72171 2.17989 2.125 2.60221 2.125 3.20581V10.8949C2.125 11.2493 2.33868 11.5686 2.6662 11.7038L7.6662 13.7673C7.87999 13.8555 8.12001 13.8555 8.3338 13.7673L13.3338 11.7038C13.6613 11.5686 13.875 11.2493 13.875 10.8949V3.2218C13.875 2.6104 13.2639 2.18751 12.6917 2.40289L9.16332 3.73105C8.69177 3.90855 8.30141 4.22546 8.0319 4.62443C7.75353 4.16461 7.3208 3.80148 6.78975 3.61424L3.29096 2.3806ZM8.375 5.9538V12.9389L13.0477 11.0105C13.0945 10.9912 13.125 10.9456 13.125 10.8949V3.2218C13.125 3.13446 13.0377 3.07404 12.956 3.10481L9.42754 4.43297C8.79428 4.67134 8.375 5.27716 8.375 5.9538ZM7.625 5.85409C7.625 5.16493 7.1903 4.55072 6.54035 4.32156L3.04157 3.08792C2.96025 3.05925 2.875 3.11958 2.875 3.20581V10.8949C2.875 10.9456 2.90553 10.9912 2.95231 11.0105L7.625 12.9389V5.85409Z"
        fill="#475161"
      />
    </svg>
  );
};

const CourseQuizIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={38}
    height={41}
    viewBox="0 0 38 41"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M9.08 2.326A2.625 2.625 0 0 1 11.426.875h10.146c.994 0 1.903.562 2.348 1.451l.774 1.549H30A2.625 2.625 0 0 1 32.625 6.5v17.924a8.625 8.625 0 1 1-8.987 14.701H3A2.625 2.625 0 0 1 .375 36.5v-30A2.625 2.625 0 0 1 3 3.875h5.305l.774-1.549Zm12.304 34.549a8.625 8.625 0 0 1 8.991-13.296V6.5A.375.375 0 0 0 30 6.125h-4.326c.223 1.517-.943 3-2.601 3H9.927c-1.658 0-2.824-1.483-2.601-3H3a.375.375 0 0 0-.375.375v30c0 .207.168.375.375.375h18.384Zm-9.957-33.75a.375.375 0 0 0-.335.207l-1.5 3a.375.375 0 0 0 .335.543h13.146c.279 0 .46-.293.335-.543l-1.5-3a.375.375 0 0 0-.335-.207H11.427ZM22.125 32a6.375 6.375 0 1 1 12.75 0 6.375 6.375 0 0 1-12.75 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M6.375 15.5c0-.621.504-1.125 1.125-1.125h18a1.125 1.125 0 0 1 0 2.25h-18A1.125 1.125 0 0 1 6.375 15.5ZM6.375 21.5c0-.621.504-1.125 1.125-1.125h9a1.125 1.125 0 0 1 0 2.25h-9A1.125 1.125 0 0 1 6.375 21.5ZM32.203 29.622c.485.388.564 1.096.175 1.58l-3 3.75a1.125 1.125 0 0 1-1.502.234l-2.25-1.5a1.125 1.125 0 0 1 1.248-1.872l1.392.928 2.356-2.945a1.125 1.125 0 0 1 1.58-.175Z"
      clipRule="evenodd"
    />
  </svg>
);

const LearningPathLevelIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.375 5C11.375 4.79289 11.2071 4.625 11 4.625C10.7929 4.625 10.625 4.79289 10.625 5L10.625 11C10.625 11.2071 10.7929 11.375 11 11.375C11.2071 11.375 11.375 11.2071 11.375 11L11.375 5Z"
        fill="#475161"
      />
      <path
        d="M8 5.625C8.20711 5.625 8.375 5.79289 8.375 6L8.375 11C8.375 11.2071 8.20711 11.375 8 11.375C7.79289 11.375 7.625 11.2071 7.625 11L7.625 6C7.625 5.79289 7.79289 5.625 8 5.625Z"
        fill="#475161"
      />
      <path
        d="M5 7.625C5.20711 7.625 5.375 7.79289 5.375 8L5.375 11C5.375 11.2071 5.20711 11.375 5 11.375C4.79289 11.375 4.625 11.2071 4.625 11V8C4.625 7.79289 4.79289 7.625 5 7.625Z"
        fill="#475161"
      />
    </svg>
  );
};

const RemoveBookmarkIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={16}
    viewBox="0 0 18 16"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M0 1.72C0 1.048.553.5 1.235.5h15.53C17.447.5 18 1.047 18 1.72v12.56c0 .673-.553 1.22-1.235 1.22H1.235A1.228 1.228 0 0 1 0 14.28V1.72Zm1.059 0c0-.095.079-.173.176-.173h15.53c.097 0 .176.078.176.174v9.9l-2.826-2.793-.001-.002a1.237 1.237 0 0 0-.879-.363 1.248 1.248 0 0 0-.878.363l-.002.002-1.815 1.793-.002.003a.175.175 0 0 1-.126.052.177.177 0 0 1-.126-.052l-.003-.003L6.35 6.733a1.236 1.236 0 0 0-.878-.363 1.248 1.248 0 0 0-.879.363L1.06 10.225V1.721Zm0 9.985 4.283-4.233.003-.003a.177.177 0 0 1 .194-.039.176.176 0 0 1 .057.039l.003.003 3.934 3.888a1.236 1.236 0 0 0 .879.363 1.247 1.247 0 0 0 .878-.363l.002-.002 1.815-1.793.003-.003a.177.177 0 0 1 .251 0l.003.003L16.94 13.1v1.178a.175.175 0 0 1-.176.175H1.235a.175.175 0 0 1-.176-.175v-2.574Z"
      clipRule="evenodd"
    />
    <path
      fill="#475161"
      d="M11.47 6.43c.488 0 .883-.39.883-.872a.877.877 0 0 0-.882-.872.877.877 0 0 0-.883.872c0 .482.395.872.883.872Z"
    />
  </svg>
);

const LearningPathVideoIcon = (props) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.91943 6.75788C8.50277 6.42109 8.50277 5.57913 7.91943 5.24234L5.23339 3.69155C4.65005 3.35476 3.92089 3.77574 3.92089 4.44932L3.92089 7.5509C3.92089 8.22447 4.65005 8.64546 5.23339 8.30867L7.91943 6.75788ZM7.54443 5.89186C7.62777 5.93997 7.62777 6.06025 7.54443 6.10836L4.85839 7.65915C4.77505 7.70726 4.67089 7.64712 4.67089 7.5509V4.44932C4.67089 4.35309 4.77505 4.29295 4.85839 4.34107L7.54443 5.89186Z"
        fill="#475161"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.917969 0.0437012C0.434719 0.0437012 0.0429688 0.435453 0.0429688 0.918702V11.0815C0.0429688 11.5647 0.43472 11.9565 0.917969 11.9565H11.0808C11.564 11.9565 11.9558 11.5647 11.9558 11.0815V0.918701C11.9558 0.435452 11.564 0.0437012 11.0808 0.0437012H0.917969ZM0.792969 0.918702C0.792969 0.849666 0.848933 0.793701 0.917969 0.793701H11.0808C11.1498 0.793701 11.2058 0.849666 11.2058 0.918701V11.0815C11.2058 11.1505 11.1498 11.2065 11.0808 11.2065H0.917969C0.848933 11.2065 0.792969 11.1505 0.792969 11.0815V0.918702Z"
        fill="#475161"
      />
    </svg>
  );
};

const LearningPathDurationIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.375 5.75C7.375 5.54289 7.54289 5.375 7.75 5.375C7.95711 5.375 8.125 5.54289 8.125 5.75V8.0625L9.975 9.45C10.1407 9.57426 10.1743 9.80931 10.05 9.975C9.92574 10.1407 9.69069 10.1743 9.525 10.05L7.525 8.55C7.43057 8.47918 7.375 8.36803 7.375 8.25V5.75Z"
        fill="#475161"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM13.25 8C13.25 10.8995 10.8995 13.25 8 13.25C5.10051 13.25 2.75 10.8995 2.75 8C2.75 5.10051 5.10051 2.75 8 2.75C10.8995 2.75 13.25 5.10051 13.25 8Z"
        fill="#475161"
      />
    </svg>
  );
};
const LearningPathLineIcon = (props) => {
  return (
    <svg
      width="2"
      height="15"
      viewBox="0 0 2 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.38636 0.460227V14.8125H0.534091V0.460227H1.38636Z"
        fill="#6E6B86"
      />
    </svg>
  );
};
const LearningPathAssignmentIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={14}
      fill="none"
      {...props}
    >
      <path
        fill="#475161"
        fillRule="evenodd"
        d="M2 2.376A.625.625 0 0 0 1.375 3v9c0 .345.28.625.625.625h8c.345 0 .625-.28.625-.625V3A.625.625 0 0 0 10 2.376H8.153v-.75H10c.76 0 1.375.615 1.375 1.375v9c0 .76-.616 1.375-1.375 1.375H2C1.24 13.376.625 12.76.625 12V3c0-.76.616-1.375 1.375-1.375h1.847v.75H2Z"
        clipRule="evenodd"
      />
      <path
        fill="#475161"
        fillRule="evenodd"
        d="M3.175 2c0-.731.593-1.324 1.325-1.324h3a1.325 1.325 0 1 1 0 2.65h-3A1.325 1.325 0 0 1 3.175 2ZM4.5 1.327a.675.675 0 0 0 0 1.35h3a.675.675 0 0 0 0-1.35h-3ZM3.125 5c0-.206.168-.374.375-.374h5a.375.375 0 1 1 0 .75h-5A.375.375 0 0 1 3.125 5ZM3.125 10c0-.206.168-.374.375-.374h5a.375.375 0 0 1 0 .75h-5A.375.375 0 0 1 3.125 10ZM3.125 7.5c0-.206.168-.374.375-.374h5a.375.375 0 1 1 0 .75h-5a.375.375 0 0 1-.375-.375Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
const LearningPathArticlesIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={12}
      height={12}
      fill="none"
      {...props}
    >
      <path
        fill="#475161"
        d="M3.5 3.125a.375.375 0 1 0 0 .75h5a.375.375 0 1 0 0-.75h-5ZM3.125 6c0-.207.168-.375.375-.375h5a.375.375 0 1 1 0 .75h-5A.375.375 0 0 1 3.125 6ZM3.5 8.125a.375.375 0 1 0 0 .75h5a.375.375 0 1 0 0-.75h-5Z"
      />
      <path
        fill="#475161"
        fillRule="evenodd"
        d="M1.25.375a.875.875 0 0 0-.875.875v9.5c0 .483.392.875.875.875h9.5a.875.875 0 0 0 .875-.875v-9.5a.875.875 0 0 0-.875-.875h-9.5Zm-.125.875c0-.069.056-.125.125-.125h9.5c.069 0 .125.056.125.125v9.5a.125.125 0 0 1-.125.125h-9.5a.125.125 0 0 1-.125-.125v-9.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
const LearningPathCertificateCompletionIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={13}
      height={14}
      fill="none"
      {...props}
    >
      <path
        fill="#475161"
        fillRule="evenodd"
        d="M3.026.609A.875.875 0 0 1 3.81.125h3.382c.331 0 .634.187.783.484l.258.516H10c.483 0 .875.392.875.875v5.974A2.874 2.874 0 0 1 9.5 13.375c-.601 0-1.16-.184-1.62-.5H1A.875.875 0 0 1 .125 12V2c0-.483.392-.875.875-.875h1.768l.258-.516Zm4.102 11.516a2.875 2.875 0 0 1 2.997-4.432V2A.125.125 0 0 0 10 1.875H8.558a.876.876 0 0 1-.867 1H3.309a.876.876 0 0 1-.867-1H1A.125.125 0 0 0 .875 2v10c0 .069.056.125.125.125h6.128ZM3.809.875a.125.125 0 0 0-.112.07l-.5 1a.125.125 0 0 0 .112.18h4.382a.125.125 0 0 0 .112-.18l-.5-1a.125.125 0 0 0-.112-.07H3.809ZM7.375 10.5a2.125 2.125 0 1 1 4.25 0 2.125 2.125 0 0 1-4.25 0Z"
        clipRule="evenodd"
      />
      <path
        fill="#475161"
        fillRule="evenodd"
        d="M2.125 5c0-.207.168-.375.375-.375h6a.375.375 0 1 1 0 .75h-6A.375.375 0 0 1 2.125 5ZM2.125 7c0-.207.168-.375.375-.375h3a.375.375 0 1 1 0 .75h-3A.375.375 0 0 1 2.125 7ZM10.734 9.707c.162.13.188.365.059.527l-1 1.25a.375.375 0 0 1-.501.078l-.75-.5a.375.375 0 1 1 .416-.624l.464.31.785-.982a.375.375 0 0 1 .527-.059Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
const LearningPathBadgeIcon = (props) => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.03699 0.713895C5.01299 0.705723 4.98701 0.705723 4.96301 0.713895L0.776962 2.13889C0.729593 2.15502 0.697674 2.20004 0.697674 2.25073V5.1953C0.697674 7.9495 2.42867 10.3964 4.99927 11.2787C7.57348 10.3667 9.30233 7.90168 9.30233 5.12972V2.16588L5.03699 0.713895ZM4.74106 0.0428986C4.90908 -0.0142995 5.09092 -0.0142996 5.25894 0.0428986L9.63918 1.534C9.85474 1.60738 10 1.81227 10 2.04293V5.12972C10 8.23262 8.04603 10.9886 5.14628 11.9758C5.05136 12.0081 4.94864 12.0081 4.85372 11.9758L4.79244 11.9549C1.9293 10.9802 0 8.25902 0 5.1953V2.25073C0 1.89592 0.223432 1.58077 0.555011 1.4679L4.74106 0.0428986Z"
        fill="#475161"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.35799 5.38256C3.49422 5.24436 3.71509 5.24436 3.85132 5.38256L4.9202 6.4669L6.64685 4.71527C6.78308 4.57707 7.00396 4.57707 7.14018 4.71527C7.27641 4.85347 7.27641 5.07753 7.14018 5.21573L5.16686 7.2176C5.03063 7.3558 4.80976 7.3558 4.67353 7.2176L3.35799 5.88302C3.22176 5.74482 3.22176 5.52076 3.35799 5.38256Z"
        fill="#475161"
      />
    </svg>
  );
};
const LearningPathSkillBadgeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={16}
    viewBox="0 0 14 16"
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M7.002 9.379c-1.853 0-3.36-1.468-3.36-3.273 0-1.804 1.507-3.272 3.36-3.272 1.854 0 3.36 1.468 3.36 3.272 0 1.805-1.506 3.273-3.36 3.273Zm0-5.76c-1.408 0-2.553 1.116-2.553 2.487 0 1.372 1.145 2.488 2.553 2.488 1.409 0 2.554-1.116 2.554-2.488 0-1.37-1.145-2.487-2.554-2.487Zm6.667 9.027-2.01-3.392c.185-.323.167-.704.15-1.043-.011-.213-.024-.434.025-.576.043-.13.181-.295.315-.455.248-.297.529-.634.529-1.074 0-.44-.282-.777-.53-1.073-.133-.16-.27-.325-.314-.456-.048-.142-.036-.363-.026-.575.02-.376.041-.801-.215-1.145-.26-.345-.683-.457-1.058-.554-.21-.055-.428-.111-.548-.197-.118-.084-.239-.266-.355-.441-.212-.32-.453-.681-.876-.815-.408-.129-.813.021-1.17.154-.209.078-.424.158-.585.158-.16 0-.374-.08-.583-.158C6.06.871 5.655.721 5.247.85c-.423.134-.664.496-.876.815-.116.176-.237.357-.355.442-.12.086-.338.142-.548.197-.375.097-.8.209-1.058.554-.257.344-.235.77-.216 1.145.01.212.023.433-.025.575-.043.13-.182.296-.315.456-.249.296-.53.634-.53 1.073 0 .441.281.778.53 1.074.132.16.27.324.314.455.047.143.036.363.025.577-.018.34-.035.719.151 1.042l-2.01 3.393a.382.382 0 0 0 .006.403.41.41 0 0 0 .369.185l2.149-.135.954 1.88c.067.13.2.215.35.22h.012a.406.406 0 0 0 .35-.197l2.331-3.932A.75.75 0 0 1 7 11.053a.74.74 0 0 1 .144.018l2.332 3.932a.406.406 0 0 0 .35.197h.013a.405.405 0 0 0 .348-.22l.955-1.88 2.15.135c.147.01.289-.061.368-.185a.382.382 0 0 0 .006-.403l.004-.002Zm-9.464 1.328-.74-1.458a.407.407 0 0 0-.388-.217l-1.666.104L2.98 9.758c.161.065.33.11.49.151.21.056.427.112.548.198.118.084.239.265.355.44.212.32.453.683.876.816.162.05.323.057.48.039l-1.524 2.57.001.002Zm2.293-3.624a5.685 5.685 0 0 0-.366.125c-.244.091-.497.185-.634.141-.151-.048-.302-.275-.448-.495-.156-.236-.319-.48-.557-.65-.242-.171-.533-.247-.814-.32-.224-.059-.454-.119-.57-.214-.004-.004-.007-.008-.013-.012a.2.2 0 0 1-.032-.034c-.088-.119-.075-.385-.062-.642.015-.285.03-.58-.063-.858-.09-.27-.276-.493-.456-.708-.171-.204-.348-.417-.348-.578 0-.16.177-.373.348-.578.18-.215.367-.44.456-.708.093-.28.078-.574.063-.858-.014-.258-.027-.524.062-.642.091-.122.357-.192.614-.26.281-.073.572-.148.814-.32.24-.17.4-.413.557-.65.146-.22.298-.446.448-.495.137-.044.39.05.633.142.263.098.563.21.87.21.31 0 .607-.112.87-.21.244-.091.496-.186.634-.142.151.049.301.276.447.495.157.237.32.481.558.65.242.172.532.247.814.32.257.068.524.137.614.259.088.118.075.385.062.642-.015.284-.03.579.063.858.09.27.276.493.456.707.17.205.348.418.348.578 0 .162-.177.374-.348.578-.181.216-.367.439-.456.708-.093.28-.078.573-.063.858.014.257.027.523-.062.642-.091.122-.357.191-.614.259-.282.072-.572.149-.814.32-.24.17-.401.414-.558.65-.146.22-.297.447-.447.495-.138.044-.39-.05-.633-.141a5.755 5.755 0 0 0-.328-.112c-.013-.005-.026-.01-.04-.013A1.783 1.783 0 0 0 7 10.263c-.173 0-.34.036-.504.084l.003.003Zm4.43 1.948a.409.409 0 0 0-.388.218l-.74 1.457L8.274 11.4c.052.007.103.014.155.014.108 0 .218-.014.328-.05.423-.133.664-.495.876-.814.116-.176.237-.357.355-.441.12-.086.338-.142.547-.197.16-.042.33-.088.49-.152l1.568 2.645-1.666-.104v-.002Z"
    />
  </svg>
);
const LearningPathSkillCertificateIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={38}
    height={41}
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M9.08 2.326A2.625 2.625 0 0 1 11.426.875h10.146c.994 0 1.903.562 2.348 1.451l.774 1.549H30A2.625 2.625 0 0 1 32.625 6.5v17.924a8.625 8.625 0 1 1-8.987 14.701H3A2.625 2.625 0 0 1 .375 36.5v-30A2.625 2.625 0 0 1 3 3.875h5.305l.774-1.549Zm12.304 34.549a8.625 8.625 0 0 1 8.991-13.296V6.5A.375.375 0 0 0 30 6.125h-4.326c.223 1.517-.943 3-2.601 3H9.927c-1.658 0-2.824-1.483-2.601-3H3a.375.375 0 0 0-.375.375v30c0 .207.168.375.375.375h18.384Zm-9.957-33.75a.375.375 0 0 0-.335.207l-1.5 3a.375.375 0 0 0 .335.543h13.146c.279 0 .46-.293.335-.543l-1.5-3a.375.375 0 0 0-.335-.207H11.427ZM22.125 32a6.375 6.375 0 1 1 12.75 0 6.375 6.375 0 0 1-12.75 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M6.375 15.5c0-.621.504-1.125 1.125-1.125h18a1.125 1.125 0 0 1 0 2.25h-18A1.125 1.125 0 0 1 6.375 15.5ZM6.375 21.5c0-.621.504-1.125 1.125-1.125h9a1.125 1.125 0 0 1 0 2.25h-9A1.125 1.125 0 0 1 6.375 21.5ZM32.203 29.622c.485.388.564 1.096.175 1.58l-3 3.75a1.125 1.125 0 0 1-1.502.234l-2.25-1.5a1.125 1.125 0 0 1 1.248-1.872l1.392.928 2.356-2.945a1.125 1.125 0 0 1 1.58-.175Z"
      clipRule="evenodd"
    />
  </svg>
);

const CertificateSkillBadgeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      d="M18 13.875a1.125 1.125 0 0 0 0 2.25h12a1.125 1.125 0 0 0 0-2.25H18ZM16.875 24c0-.621.504-1.125 1.125-1.125h12a1.125 1.125 0 0 1 0 2.25H18A1.125 1.125 0 0 1 16.875 24ZM18 31.875a1.125 1.125 0 0 0 0 2.25h12a1.125 1.125 0 0 0 0-2.25H18Z"
    />
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M14.47 7.554a2.625 2.625 0 0 0-2.626 2.625v18.859h-6.2a2.625 2.625 0 0 0-2.624 2.625v3.294a5.538 5.538 0 0 0 5.169 5.526v.012h25.343a2.625 2.625 0 0 0 2.625-2.625V19.012h6.202a2.625 2.625 0 0 0 2.625-2.625v-3.295a5.538 5.538 0 0 0-5.907-5.526v-.012H14.47Zm19.439 5.538-.002 24.778a.375.375 0 0 1-.375.375H13.014a5.512 5.512 0 0 0 1.08-3.288V10.18c0-.207.168-.375.375-.375h20.52a5.513 5.513 0 0 0-1.08 3.288ZM11.844 31.288v3.67a3.288 3.288 0 1 1-6.574 0v-3.295c0-.207.167-.375.375-.375h6.2ZM39.446 9.804a3.288 3.288 0 0 0-3.287 3.288v3.67h6.2a.375.375 0 0 0 .375-.375v-3.295a3.288 3.288 0 0 0-3.288-3.288Z"
      clipRule="evenodd"
    />
  </svg>
);

const CancelIconModal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      d="M19.148 6.148a.562.562 0 1 0-.796-.796L12 11.704 5.648 5.352a.563.563 0 0 0-.796.796l6.352 6.352-6.352 6.352a.562.562 0 1 0 .796.796L12 13.296l6.352 6.352a.562.562 0 1 0 .796-.796L12.796 12.5l6.352-6.352Z"
    />
  </svg>
);

const SideBarCancelIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    {...props}
  >
    <rect
      width={25}
      height={25}
      x={0.5}
      y={0.5}
      fill="#DDE3EE"
      rx={12.5}
    />
    <rect
      width={25}
      height={25}
      x={0.5}
      y={0.5}
      stroke="#B6AEF3"
      rx={12.5}
    />
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M15.265 7.735a.375.375 0 0 1 0 .53L10.53 13l4.735 4.735a.375.375 0 0 1-.53.53l-5-5a.375.375 0 0 1 0-.53l5-5a.375.375 0 0 1 .53 0Z"
      clipRule="evenodd"
    />
  </svg>
);
const SideBarOpenIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    style={{ transform: "rotate(180deg)" }}
    {...props}
  >
    <rect
      width={25}
      height={25}
      x={0.5}
      y={0.5}
      fill="#DDE3EE"
      rx={12.5}
    />
    <rect
      width={25}
      height={25}
      x={0.5}
      y={0.5}
      stroke="#B6AEF3"
      rx={12.5}
    />
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M15.265 7.735a.375.375 0 0 1 0 .53L10.53 13l4.735 4.735a.375.375 0 0 1-.53.53l-5-5a.375.375 0 0 1 0-.53l5-5a.375.375 0 0 1 .53 0Z"
      clipRule="evenodd"
    />
  </svg>
);

const NewVideoIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={13}
    viewBox="0 0 12 13"
    fill="none"
    {...props}
  >
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M6 1.206a5.294 5.294 0 1 0 0 10.588A5.294 5.294 0 0 0 6 1.206ZM0 6.5a6 6 0 1 1 12 0 6 6 0 0 1-12 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#475161"
      fillRule="evenodd"
      d="M8.235 6.5a.353.353 0 0 1-.176.306l-2.824 1.63a.353.353 0 0 1-.53-.306V4.87a.353.353 0 0 1 .53-.306l2.824 1.63c.109.063.176.18.176.306ZM5.412 5.481V7.52L7.176 6.5 5.412 5.481Z"
      clipRule="evenodd"
    />
  </svg>
);
export {
  LearningPathCourseIcon,
  NewVideoIcon,
  CancelIconModal,
  RemoveBookmarkIcon,
  CourseQuizIcon,
  LearningPathLevelIcon,
  SideBarCancelIcon,
  LearningPathDurationIcon,
  LearningPathSkillBadgeIcon,
  LearningPathSkillCertificateIcon,
  CertificateSkillBadgeIcon,
  LearningPathAssignmentIcon,
  LearningPathArticlesIcon,
  LearningPathLineIcon,
  LearningPathCertificateCompletionIcon,
  LearningPathBadgeIcon,
  LearningPathVideoIcon,
  GenericNotFoundIcon,
  SideBarOpenIcon,
};
